import React from 'react';
import { useNavigate } from "react-router-dom";
import { Dropdown, Menu, Button } from 'antd';


type Props = {
    faviconUrl: string | null;
    websiteGuid: string;
    domain: string;
};


const settingsItems = [
    { key: 'competitors', path: '/dashboard/settings/competitors', title: 'Competitors' },
    { key: 'keywords', path: '/dashboard/settings/keywords', title: 'Keywords' },
    { key: 'monitor-locations', path: '/dashboard/settings/monitor-locations', title: 'Monitor Locations' },
    { key: 'notifications', path: '/dashboard/settings/notifications', title: 'Uptime Notifications' },
    { key: 'remove-url', path: '/dashboard/settings/remove-url', title: 'Remove Domain' },
];


export default function WebsiteTab({ faviconUrl, websiteGuid, domain }: Props) {
    const navigate = useNavigate();

    const menu = (
        <Menu className="url-options">
            {settingsItems.map((item) => (
                <Menu.Item
                    key={item.key}
                    onClick={() => navigate(`/dashboard/settings/${item.key}?w_guid=${websiteGuid}`)}
                >
                    {item.title}
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <div className="website-tab-container">
            <div className="favicon-container">
                {faviconUrl ? <img src={faviconUrl} alt={`Favicon of ${domain}`} /> : <img src="/images/default_favicon.png" alt="Default favicon" />}
            </div>

            {domain}

            <Dropdown overlay={menu} placement="bottomRight">
                <Button icon="ellipsis"></Button>
            </Dropdown>
        </div>
    );
}
